import { get, flow } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  FeatureSpecsPaths,
  VehicleModel,
  buildMmysMsrpPricesPath,
  buildUsedTmvPricingPath,
} from 'client/data/models/vehicle-v2';
import { getParamsFromVehicle } from 'site-modules/shared/utils/core-page/params';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';
import { isPreProd, isUsed } from 'site-modules/shared/utils/publication-states';
import { buildMMYSubmodelTypeAmountsPath, InventoryAggregateModel } from 'client/data/models/inventory-aggregate';
import { withTrimSummary } from 'site-modules/personalized-search/components/with-trim-summary/with-trim-summary';
import { buildPreProdContentPath, EditorialReviewModel } from 'client/data/models/editorial-review';

export const highlightsDataProvider = flow(
  component =>
    connectToModel(component, {
      style: bindToPath(
        ({ trimSummary }) => trimSummary?.styleId && FeatureSpecsPaths.buildStyleFeaturesPath(trimSummary.styleId),
        VehicleModel,
        null,
        false
      ),
      msrpPriceRanges: bindToPath(
        ({ vehicle }) =>
          vehicle && !isUsed(vehicle.pubStates) && buildMmysMsrpPricesPath(getParamsFromVehicle(vehicle)),
        VehicleModel,
        priceRanges => {
          priceRanges.sort((a, b) => a - b);

          return {
            min: priceRanges?.[0],
            max: priceRanges?.[1],
          };
        }
      ),
      usedTmv: bindToPath(
        ({ vehicle, trimSummary, submodelAmounts }) =>
          vehicle &&
          isUsed(vehicle.pubStates) &&
          trimSummary?.styleId &&
          submodelAmounts &&
          !get(submodelAmounts, `priceRanges["${vehicle.submodels?.slug}"]`) &&
          buildUsedTmvPricingPath(trimSummary.styleId),
        VehicleModel,
        data => ({
          min: get(data, 'ROUGH.Current.totalWithOptions.usedTmvRetail', 0),
          max: get(data, 'OUTSTANDING.Current.totalWithOptions.usedTmvRetail', 0),
        })
      ),
      editorialRating: bindToPath(
        ({ vehicle }) => vehicle && PersonalizedSearchPaths.getEditorialRatingPath(getParamsFromVehicle(vehicle)),
        PersonalizedSearchModel
      ),
      recommendedTrim: bindToPath(
        ({ vehicle }) => vehicle && PersonalizedSearchPaths.getRecommendedTrimPath(getParamsFromVehicle(vehicle)),
        PersonalizedSearchModel,
        recommendedTrim => recommendedTrim?.displayName
      ),
      firstContent: bindToPath(
        ({ vehicle, trimSummary }) =>
          !trimSummary?.pricing?.suggestedPrice &&
          vehicle &&
          !isUsed(vehicle.pubStates) &&
          isPreProd(vehicle.pubStates) &&
          buildPreProdContentPath(getParamsFromVehicle(vehicle)),
        EditorialReviewModel
      ),
      averagePrice: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          isUsed(vehicle.pubStates) &&
          PersonalizedSearchPaths.getAveragePricePath(getParamsFromVehicle(vehicle)),
        PersonalizedSearchModel
      ),
    }),
  component =>
    connectToModel(component, {
      submodelAmounts: bindToPath(
        ({ vehicle }) =>
          vehicle &&
          isUsed(vehicle.pubStates) &&
          buildMMYSubmodelTypeAmountsPath({ ...getParamsFromVehicle(vehicle), isUsed: true }),
        InventoryAggregateModel
      ),
    }),
  withTrimSummary({})
);
